import {
  createStrictContext,
  swrResponseToResult,
  useClient,
  useCurrentUser,
} from "@indietabletop/appkit";
import { useCallback } from "react";
import useSWR from "swr";
// import { createStrictContext } from "../oss/createStrictContext";

export type CheckAccessResult = ReturnType<typeof useGetUnlocks>;

export const [UnlocksContext, useUnlocksResult] =
  createStrictContext<CheckAccessResult>("Unlocks Context");

/**
 * Checks with the API to see which unlocks this user has access to.
 */
export function useGetUnlocks(props: {
  gameCode: string;

  /**
   * Explicitly opt into fetching.
   *
   * If not provided, will check only if current user is found in store.
   */
  performFetch?: boolean;
}) {
  const { gameCode } = props;

  const client = useClient();
  const currentUser = useCurrentUser();
  const performFetch = props.performFetch ?? !!currentUser;

  const swr = useSWR(
    performFetch ? `unlocks:${gameCode}` : null,
    useCallback(() => {
      return client.getUnlocks(gameCode);
    }, [gameCode, client]),
  );

  return swrResponseToResult(swr);
}
